export type Option = {
  value?: string | number | null;
  children?: Option[];
};

const isInOptions = (value: any, options: Option[]): boolean =>
  options.some(
    (option) =>
      option.value === value ||
      (option.children ? isInOptions(value, option.children) : false),
  );

export const notInOptions = (value: any, options: Option[] = []): boolean =>
  !isInOptions(value, options);
